import { CodedError } from '@faro/realtime-services';
import type { AxiosError } from 'axios';
import type { ReactNode } from 'react';
import { formatProblem } from './formatProblem';
import { isProblem } from './isProblem';

export function formatError(error: unknown): ReactNode {
    if (error == null) {
        return 'Unknown Error';
    }

    // If the error is a thrown string return that
    if (typeof error === 'string') {
        return error;
    }

    // This is an Axios HTTP error
    const errorAsAxiosError = error as AxiosError;
    if (isProblem(errorAsAxiosError)) {
        return formatProblem(errorAsAxiosError.response.data);
    }

    if (error instanceof CodedError) {
        switch (error.code) {
            case 'change_event_listener.timeout': {
                return error.code;
            }
        }
    }

    if (error instanceof Error) {
        return (error as Error).message;
    }

    // Do not display error messages for client-thrown errors
    console.error('Failed to format error for rendering', error);
    return;
}
